/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Build_Dose_SetsInputs */

const en_us2_plan_build_dose_sets = /** @type {(inputs: Plan_Build_Dose_SetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sets`)
};

const pt_br2_plan_build_dose_sets = /** @type {(inputs: Plan_Build_Dose_SetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Séries`)
};

const es_419_plan_build_dose_sets = /** @type {(inputs: Plan_Build_Dose_SetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Series`)
};

const pt_pt2_plan_build_dose_sets = /** @type {(inputs: Plan_Build_Dose_SetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Séries`)
};

const fr_fr2_plan_build_dose_sets = /** @type {(inputs: Plan_Build_Dose_SetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Séries`)
};

const de_de2_plan_build_dose_sets = /** @type {(inputs: Plan_Build_Dose_SetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sätze`)
};

const it_it2_plan_build_dose_sets = /** @type {(inputs: Plan_Build_Dose_SetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Serie`)
};

/**
* | output |
* | --- |
* | "Sets" |
*
* @param {Plan_Build_Dose_SetsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_build_dose_sets = /** @type {((inputs?: Plan_Build_Dose_SetsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Build_Dose_SetsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_build_dose_sets(inputs)
	if (locale === "es-419") return es_419_plan_build_dose_sets(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_build_dose_sets(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_build_dose_sets(inputs)
	if (locale === "de-DE") return de_de2_plan_build_dose_sets(inputs)
	if (locale === "it-IT") return it_it2_plan_build_dose_sets(inputs)
	return en_us2_plan_build_dose_sets(inputs)
});
export { plan_build_dose_sets as "plan-build.dose_sets" }